import React from 'react';
import { ArrowDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import HeroImage from '../assets/herosec_image.a25f8d6d.png';
import CBTImage3 from '../assets/cbt-image-3.png';

export default function CouplesTherapyPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-100">
      {/* Hero Section with Background Image */}
      <section className="relative min-h-[600px] flex items-end bg-cover bg-center" 
               style={{
                 backgroundImage: `url(${HeroImage})`
               }}>
        <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 w-full pb-0">
          <div className="flex flex-col lg:flex-row items-end gap-8 lg:gap-12">
            {/* Left Content Card - Positioned at bottom */}
            <div className="lg:w-1/2 w-full relative mb-0">
              <div className="bg-slate-700/50 backdrop-blur-sm p-8 md:p-10 lg:p-12 rounded-t-lg shadow-lg">
                <h1 className="text-3xl md:text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                  Couple Therapy
                </h1>
                <p className="text-sm md:text-base text-white/90 leading-relaxed mb-8">
                  Couple therapy helps couple who are experiencing psychological problems, 
                  especially distress in their relationship. A common approach is cognitive 
                  behavioural couple therapy (BCT) helps to deal with depression, anxiety, alcohol 
                  misuse etc.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center mb-16">
                  <button onClick={() => navigate('/book-now')} className="bg-white hover:bg-gray-100 text-green-600 px-6 py-3 rounded font-medium transition-colors">
                    BOOK NOW
                  </button>
                </div>
              </div>
              {/* Arrow button positioned at bottom right corner of card */}
              <button onClick={() => navigate('/book-now')} className="absolute bottom-0 right-0 bg-green-600 hover:bg-green-700 text-white p-3 rounded-tl-lg transition-colors shadow-lg">
                <ArrowDown className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="py-12 md:py-16 lg:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* BCT Section */}
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-black mb-6">
              What is Behavioural Couples Therapy (BCT)?
            </h2>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed max-w-4xl mx-auto">
              BCT is a treatment for two persons who are in an intimate relationship. The couple are given a safe space to resolve the 
              difficulties that are leading to distress in their relationship. The therapists teach coping skills to the couple. The 
              therapist also listens and guide the couple to work through their difficulties. BCT involves 12 to 16 weekly 
              outpatient couples' sessions.
            </p>
          </div>

          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
            {/* Left Content */}
            <div className="lg:w-1/2 space-y-8">
              <div>
                <h3 className="text-lg md:text-xl lg:text-2xl font-bold text-black mb-6">
                  Benefits of Behavioural Couples Therapy (BCT):
                </h3>
                
                <div className="space-y-4 text-sm md:text-base text-gray-700 leading-relaxed">
                  <p className="mb-4">
                    Studies have showed that individual therapy for depression contributes not much to resolving 
                    relationship problems. But BCT helps the couple to:
                  </p>
                  
                  <ul className="space-y-2 list-disc list-inside">
                    <li>manage factors that relieve stress and increase support within the relationship.</li>
                    <li>improve communication between partners.</li>
                    <li>listen and share feelings and thoughts safely.</li>
                    <li>appreciate each other's strengths and contributions to the relationship.</li>
                    <li>see positive changes and skills to relate on the relationship.</li>
                    <li>express individual needs safely.</li>
                    <li>safely talk about difficulty topics or issues in the relationship.</li>
                    <li>talk openly and honestly.</li>
                    <li>solve problems and promote acceptance.</li>
                    <li>change or revise unhelpful perceptions or assumptions.</li>
                    <li>work as a team to achieve personal and joint goals.</li>
                    <li>improve the relationship for both partners.</li>
                    <li>enjoy fun activities.</li>
                    <li>increase commitment to the relationship for both partners.</li>
                    <li>reduce low mood or depression, where low mood or depression affects one or both partners and is leading to distress in their relationship.</li>
                    <li>reduces distress in the relationship for both partners.</li>
                  </ul>
                </div>
              </div>
            </div>
            
            {/* Right Content - Image taken from HomePage assets */}
            <div className="lg:w-1/2">
              <div className="rounded-lg h-64 md:h-80 lg:h-96 overflow-hidden shadow-md">
                <img
                  src={CBTImage3}
                  alt="Couple in therapy session"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}